import React, { useContext, useEffect } from 'react';
import { LicenseManager } from 'ag-grid-enterprise';
import { Watermark, APIAlert } from '@mummssoftware/common-ui';
import { PatientAssistanceContext } from '../../context';
import { PatientAssistanceTable } from './PatientAssistanceTable';
import { Container } from '../../components/layout/WrapperDiv';

LicenseManager &&
  LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_KEY as string);

export declare const RouteProps: import('react-router-dom').RouteComponentProps<{
  patientNumber?: string;
}>;

type PatientAssistanceProps = {
  smallWidget?: boolean;
  patient?: mumms.patient;
  errorInfo?: mumms.ErrorInfo;
  clearError: () => void;
} & typeof RouteProps;

export const PatientAssistance = ({
  smallWidget,
  errorInfo,
  clearError,
}: PatientAssistanceProps) => {
  const { watermark, onWidgetReady, startLoadingTime } = useContext(
    PatientAssistanceContext,
  );

  useEffect(() => {
    const loadingDuration = (Date.now() - startLoadingTime) / 1000;

    onWidgetReady && onWidgetReady('PatientAssistance' as mumms.ComponentName);
    console.log('## COMPLETED TASKS LOG WIDGET END ##', loadingDuration, 's');
  }, []);

  return (
    <Container id="patient-assistance-container">
      <APIAlert errorInfo={errorInfo} handleClose={() => clearError()} />
      {watermark?.show ? (
        <Watermark readOnly={watermark.readOnly} smallWidget={smallWidget} />
      ) : null}
      <PatientAssistanceTable smallWidget={smallWidget} />
    </Container>
  );
};

export default PatientAssistance;
